// extracted by mini-css-extract-plugin
export default {"container":"WarningsPanel_container__+MzQE","line":"WarningsPanel_line__eOd+a","row":"WarningsPanel_row__WOs5q"};